<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                (values.firstName ? values.firstName : null) +
                " " +
                (values.middleName ? values.middleName : null + " ") +
                (values.lastName ? values.lastName : null)
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              User Name:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.username ? values.username : "-" }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Email:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.email ? values.email : null
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Phone Number:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.phoneNumber ? values.phoneNumber : "-" }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Expert Levels:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.expertLevels ? values.expertLevels.name : null
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Region:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.region ? values.region.name : "-" }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Facility Type:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.facilityType ? values.facilityType.name : "-" }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Facility:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.userFacility ? values.userFacility.name : (values.educationalInstitution ?
                    values.educationalInstitution.name : '-')
              }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              User Group:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.userGroups ? values.userGroups.groupName : "-" }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              User Role:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.userRoles ? values.userRoles.roleName : "-" }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    user: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.user != null) {
      this.values = this.user;
    }
  },
};
</script>
